Whether to include only hirer-scoped webhook subscriptions (true), only partner-scoped webhook subscriptions (false), or all webhook subscriptions (null / not provided).
